const member = () => import(/* webpackChunkName: "group-index" */ '../pages/home')
const detail = () => import(/* webpackChunkName: "group-detail" */ '../pages/detail')

const memberDetail = () => import(/* webpackChunkName: "group-memberDetail" */ '../pages/memberDetail')

const pointList = () => import(/* webpackChunkName: "group-pointList" */ '../pages/pointList')

const addrManager = () => import(/* webpackChunkName: "group-address" */ '../pages/addrManager')
const updateAddress = () => import(/* webpackChunkName: "group-address" */ '../pages/updateAddress')
const cityList = () => import(/* webpackChunkName: "group-address" */ '../pages/cityList')
const locationList = () => import(/* webpackChunkName: "group-address" */ '../pages/locationList')
const countryList = () => import(/* webpackChunkName: "group-address" */ '../pages/countryList')
const shopList = () => import(/* webpackChunkName: "group-address" */ '../pages/shopList')

const orderList = () => import(/* webpackChunkName: "group-orderList" */ '../pages/orderList')
const orderDetail = () => import(/* webpackChunkName: "group-orderList" */ '../pages/orderDetail')

const category = () => import(/* webpackChunkName: "group-bottomnav" */ '../pages/category')
const goodsList = () => import(/* webpackChunkName: "group-bottomnav" */ '../pages/goodsList')
const memberCode = () => import(/* webpackChunkName: "group-bottomnav" */ '../pages/memberCode')
const shoppingCar = () => import(/* webpackChunkName: "group-bottomnav" */ '../pages/shoppingCar')
const my = () => import(/* webpackChunkName: "group-bottomnav" */ '../pages/my')
const orderConfirm = () => import(/* webpackChunkName: "group-bottomnav" */ '../pages/orderConfirm')

const transactionList = () => import(/* webpackChunkName: "group-transcation" */ '../pages/transactionList')
const transactionDetail = () => import(/* webpackChunkName: "group-transcation" */ '../pages/transactionDetail')

const collageList = () => import(/* webpackChunkName: "group-collage" */ '../pages/collageList')
const ptDetail = () => import(/* webpackChunkName: "group-collage" */ '../pages/ptDetail')
// const newerList = ()=> import(/* webpackChunkName: "group-collage" */ '../pages/newerList')

// import member from  '../pages/home'
// import detail from  '../pages/detail'
import customerService from '../pages/customerService'
// import addrManager from  '../pages/addrManager'
// import updateAddress from  '../pages/updateAddress'
// import locationList from  '../pages/locationList'
// import cityList from  '../pages/cityList'
// import countryList from  '../pages/countryList'
// import shopList from  '../pages/shopList'
// import orderList from  '../pages/orderList'
// import orderDetail from  '../pages/orderDetail'
import phoneLogin from '../pages/phoneLogin'
// import pointList from  '../pages/pointList'
// import orderConfirm from '../pages/orderConfirm'
import login from '../pages/login'
// import memberDetail from '../pages/memberDetail'
import outerPage from "../pages/outerPage"
// import my from "../pages/my"
import checkout from "../pages/checkout"
// import memberCode from "../pages/memberCode"
// import shoppingCar from "../pages/shoppingCar"
// import transactionList from "../pages/transactionList"
// import transactionDetail from "../pages/transactionDetail"
import myPromotionCode from "../pages/myPromotionCode"
import myPromoters from "../pages/myPromoters"
// import category from "../pages/category"
// import goodsList from "../pages/goodsList"
// import collageList from "../pages/collageList"
import expireGood from "../pages/expireGood"
import loadingPage from "../pages/loadingPage"
// import ptDetail from "../pages/ptDetail"
import newerList from '../pages/newerList'
import couponList from '../pages/couponList'
import search from '@/pages/search'
// console.log(newerList)
export let allPath = [
  {
    path: '/',
    name: 'member',
    component: member,
    meta: {
      title: '积惠多便利店',
      level: 1,
      miniRoute: "/pages/member/member",
      keepAlive: true,
      hideTop: true //是否隐藏导航栏
    }
  }, {
    path: '/category',
    name: 'category',
    component: category,
    meta: {
      title: '分类',
      level: 1,
      hideTop: true,
      keepAlive: true,
      miniRoute: "/pages/memberDetailwv/memberDetailwv"
    }
  }, {
    path: '/detail',
    name: 'detail',
    component: detail,
    meta: {
      title: '商品详情',
      miniRoute: "/pages/detail/detail",
      level: 1,
    },
  }, {
    path: '/customerService',
    name: 'customerService',
    component: customerService,
    meta: {
      title: '联系客服',
      level: 1,
      miniRoute: "/pages/customerService/customerService"
    },
  }, {
    path: '/addrManager',
    name: 'addrManager',
    component: addrManager,
    meta: {
      title: '收货地址',
      level: 1,
      auth: true
    },
  }, {
    path: '/updateAddress',
    name: 'updateAddress',
    component: updateAddress,
    meta: {
      title: '添加地址',
      level: 1,
      auth: true
    },
  }, {
    path: '/locationList',
    name: 'locationList',
    component: locationList,
    meta: {
      title: '选择省份',
      level: 1,
      auth: true,
    },
  }, {
    path: '/cityList',
    name: 'cityList',
    component: cityList,
    meta: {
      title: '选择城市',
      level: 1,
    },
  }, {
    path: '/countryList',
    name: 'countryList',
    component: countryList,
    meta: {
      title: '选择区/县',
      level: 1,
      auth: true,
    },
  }, {
    path: '/shopList',
    name: 'shopList',
    component: shopList,
    meta: {
      title: '选择提货点',
      level: 1,
      auth: true,
    },
  }, {
    path: '/orderList',
    name: 'orderList',
    component: orderList,
    meta: {
      title: '商城订单',
      level: 1,
      auth: true,
      miniRoute: '/pages/memberDetailwv/memberDetailwv'
    },
  }, {
    path: '/orderDetail',
    name: 'orderDetail',
    component: orderDetail,
    meta: {
      title: '订单详情',
      level: 1,
      auth: true,
      miniRoute: '/pages/memberDetailwv/memberDetailwv'
    },
  }, {
    path: '/phoneLogin',
    name: 'phoneLogin',
    component: phoneLogin,
    meta: {
      title: '绑定手机号',
      level: 1,
    },
  }, {
    path: '/pointList',
    name: 'pointList',
    component: pointList,
    meta: {
      title: '积分列表',
      level: 1,
      auth: true,
      miniRoute: "/pages/memberDetailwv/memberDetailwv"
    },
  }, {
    path: '/orderConfirm',
    name: 'orderConfirm',
    component: orderConfirm,
    meta: {
      title: '确认订单',
      level: 1,
      auth: true,
      miniRoute: "/pages/memberDetailwv/memberDetailwv"
    }
  }, {
    path: '/login',
    name: 'login',
    component: login,
    meta: {
      title: '微信登录',
      level: 1,
    }
  }, {
    path: '/memberDetail',
    name: 'memberDetail',
    component: memberDetail,
    meta: {
      title: '会员详情',
      level: 1,
      auth: true,
      miniRoute: "/pages/memberDetailwv/memberDetailwv",
    }
  }, {
    path: '/outerPage',
    name: 'outerPage',
    component: outerPage,
    meta: {
      title: '',
      level: 1,
      miniRoute: "/pages/webView/webView",
    }
  }, {
    path: '/my',
    name: 'my',
    component: my,
    meta: {
      title: '我的',
      level: 1,
      hideTop: true,
      keepAlive: true,
      miniRoute: "/pages/memberDetailwv/memberDetailwv"
      // auth:true
    }
  }, {
    path: '/memberCode',
    name: 'memberCode',
    component: memberCode,
    meta: {
      title: '会员码',
      level: 1,
      hideTop: true,
      // auth:true,
      miniRoute: "/pages/memberDetailwv/memberDetailwv"
    }
  }, {
    path: '/shoppingCar',
    name: 'shoppingCar',
    component: shoppingCar,
    meta: {
      title: '购物车',
      level: 1,
      hideTop: true,
      miniRoute: "/pages/memberDetailwv/memberDetailwv"
    }
  }, {
    path: '/myPromotionCode',
    name: 'myPromotionCode',
    component: myPromotionCode,
    meta: {
      title: '我的推广码',
      level: 1,
      auth: true,
      miniRoute: '/pages/memberDetailwv/memberDetailwv'
    }
  }, {
    path: '/myPromoters',
    name: 'myPromoters',
    component: myPromoters,
    meta: {
      title: '推广明细',
      level: 1,
      miniRoute: '/pages/memberDetailwv/memberDetailwv'
    }
  }, {
    path: '/transactionList',
    name: 'transactionList',
    component: transactionList,
    meta: {
      title: '我的交易',
      level: 1,
      auth: true,
      miniRoute: '/pages/memberDetailwv/memberDetailwv'
    }
  }, {
    path: '/transactionDetail',
    name: 'transactionDetail',
    component: transactionDetail,
    meta: {
      title: '交易详情',
      level: 1,
      miniRoute: '/pages/memberDetailwv/memberDetailwv'
    }
  }, {
    path: '/goodsList',
    name: 'goodsList',
    component: goodsList,
    meta: {
      title: '商品列表',
      level: 1,
      miniRoute: '/pages/memberDetailwv/memberDetailwv'
    }
  }, {
    path: '/collageList',
    name: 'collageList',
    component: collageList,
    meta: {
      title: '拼团商品',
      level: 1,
      miniRoute: '/pages/memberDetailwv/memberDetailwv'
    }
  }, {
    path: '/loadingPage',
    name: 'loadingPage',
    component: loadingPage,
    meta: {
      title: '',
      level: 1,
      // miniRoute: '/pages/memberDetailwv/memberDetailwv'
    }
  }, {
    path: '/expireGood',
    name: 'expireGood',
    component: expireGood,
    meta: {
      title: '商品详情',
      level: 1
    }
  }, {
    path: '/checkout',
    name: 'checkout',
    component: checkout,
    meta: {
      title: '收银台',
      level: 1
    }
  }, {
    path: '/ptDetail',
    name: 'ptDetail',
    component: ptDetail,
    meta: {
      title: '拼团详情',
      level: 1
    }
  }, {
    path: '/newerList',
    name: 'newerList',
    component: newerList,
    meta: {
      title: '新人专享',
      level: 1,
      miniRoute: "/pages/newerList/newerList"
    }
  }, {
    path: '/couponList',
    name: 'couponList',
    component: couponList,
    meta: {
      title: '领劵中心',
      level: 1,
      miniRoute: "/pages/couponList/couponList",
      auth:true
    }
  },{
    path:'/myCoupons',
    name:'myCoupons',
    component:()=>import('../pages/myCoupons'),
    meta:{
      title:'我的卡券',
      level:1,
      miniRoute:'/pages/myCoupons/myCoupons',
      auth:true
    }
  },{
    path:'/search',
    name:'search',
    component:search,
    meta:{
      title:'搜索',
      level:1,
      miniRoute:'/pages/search/search',
    }
  },{
    path:'/signIn',
    name:'signIn',
    component:()=>import('@/pages/signIn'),
    meta:{
      title:'签到',
      level:1,
      miniRoute:'/pages/signIn/signIn',
      auth:true
    }
  },{
    path:'/help',
    name:'help',
    component:()=>import('@/pages/help'),
    meta:{
      title:'',
      level:1,
      miniRoute:'/pages/help/help',
      auth:false,
      hideTop:true
    }
  },{
    path:'/help-my',
    name:'help-my',
    component:()=>import('@/pages/help/my'),
    meta:{
      title:'',
      level:1,
      miniRoute:'/pages/help/help?type=my',
      auth:false,
      hideTop:true
    }
  },{
    path:'/help-detail',
    name:'help-detail',
    component:()=>import('@/pages/help-detail'),
    meta:{
      title:'快来帮助我',
      level:1,
      miniRoute:'/pages/help-detail/help-detail',
      auth:true
    }
  }
]